import { render, staticRenderFns } from "./DriversLoadsReportTemplate.vue?vue&type=template&id=91837b88"
import script from "./DriversLoadsReportTemplate.vue?vue&type=script&lang=js"
export * from "./DriversLoadsReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports